import { fetchGet } from '../../../store/fetch';
import { InspectionStandardTypes } from '../../../utils/enums/InspectionStandardTypes';
import { isCustomerVersion } from '../../../utils/isCustomerVersion';

export async function loadSurveyElements(surveyId: string, objectId?: string, inspectionStandardType?: InspectionStandardTypes) {
    if (
        ![
            InspectionStandardTypes.Api653,
            InspectionStandardTypes.Api570,
            InspectionStandardTypes.Eemua159,
            InspectionStandardTypes.Fmeca,
            InspectionStandardTypes.Free,
            InspectionStandardTypes.Memo,
            InspectionStandardTypes.Model3d,
            InspectionStandardTypes.Nen2767,
        ].includes(inspectionStandardType as InspectionStandardTypes)
    ) {
        return [];
    }
    if (!objectId) {
        return [];
    }

    let includeDefects;
    let includeAssets;
    let includeConditions;
    let includeDerivedConditions;

    if (inspectionStandardType === InspectionStandardTypes.Fmeca) {
        includeDefects = false;
        includeAssets = true;
        includeConditions = false;
        includeDerivedConditions = true;
    } else if (inspectionStandardType === InspectionStandardTypes.Nen2767) {
        includeDefects = true;
        includeAssets = true;
        includeConditions = true;
        includeDerivedConditions = true;
    } else {
        includeDefects = true;
        includeAssets = true;
        includeConditions = true;
        includeDerivedConditions = true;
    }

    const url = `/api/objects/${objectId}/elements`;
    const result = await fetchGet(url, {
        surveyId,
        includeDefects: includeDefects.toString(),
        includeAssets: includeAssets.toString(),
        includeConditions: includeConditions.toString(),
        includeDerivedConditions: includeDerivedConditions.toString(),
        includeUtProjects: isCustomerVersion('ronik').toString(),
    });
    if (result && result.json) {
        return result.json;
    }
    return [];
}
